module.exports = __webpack_public_path__ + "img/social_share.ef81c07d.svg";